(() => {
  const root = document.querySelector('[data-ta-storefront]');
  if (!root) return;

  const toggle = root.querySelector('[data-language-toggle]');
  const picture = root.querySelector('[data-lifestyle-picture]');
  const source = root.querySelector('[data-lifestyle-source]');
  const englishImage = picture?.dataset.enImage || '';
  const arabicImage = picture?.dataset.arImage || '';

  const setLanguage = (language) => {
    const arabic = language === 'ar';
    root.dataset.language = language;
    root.dir = arabic ? 'rtl' : 'ltr';
    root.querySelectorAll('[data-copy]').forEach((node) => {
      node.hidden = node.dataset.copy !== language;
    });
    if (toggle) {
      toggle.textContent = arabic ? 'EN' : 'عربي';
      toggle.setAttribute('aria-label', arabic ? 'Switch to English' : 'التبديل إلى العربية');
    }
    if (source) source.setAttribute('srcset', arabic ? arabicImage : englishImage);
  };

  toggle?.addEventListener('click', () => {
    setLanguage(root.dataset.language === 'ar' ? 'en' : 'ar');
  });

  const observer = new IntersectionObserver(
    (entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }),
    { threshold: 0.12 },
  );
  root.querySelectorAll('.ta-reveal').forEach((node) => observer.observe(node));
})();